import React, { useState } from 'react';
import { Table } from '../../Component/Table';
import { useTranslation } from 'react-i18next';
import { Button, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import ModelModal from './ModelModal';
import Can from '../../Component/Can';
import NameByLang from '../../Component/nameByLang';
import { AnimatedContainer } from '../../Component/ui';
import './style.scss';

const Models = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [selectedModel, setSelectedModel] = useState<any>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');

  const handleEdit = (record: any) => {
    setSelectedModel(record);
    setModalMode('edit');
    setModalVisible(true);
  };

  const handleAddNew = () => {
    setSelectedModel(null);
    setModalMode('create');
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedModel(null);
  };

  const handleModalSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['/api/admin/models'] });
  };

  return (
    <AnimatedContainer className="models-page" variant="fadeUp">
      <Table
        tableQueryKey="/api/admin/models"
        tableTitle={t('models.title', 'Menu Models Management')}
        showSearch={true}
        tableFilter={{
          filters: {},
          paging: { page: 1, pageSize: 50 },
          sorting: {},
        }}
        columns={[
          {
            title: t('models.columns.name', 'Name'),
            dataIndex: 'name',
            key: 'name',
            render: (_: string, record: any) => (
              <NameByLang name_en={record.name_en} name_ar={record.name_ar} />
            ),
          },
          {
            title: t('common.actions', 'Actions'),
            key: 'actions',
            render: (_: any, record: any) => (
              <Space>
                <Can permission="models.update">
                  <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>
                    {t('common.edit', 'Edit')}
                  </Button>
                </Can>
              </Space>
            ),
          },
        ]}
        onClickNewButton={handleAddNew}
        createPermission="models.create"
      />

      <ModelModal
        visible={modalVisible}
        mode={modalMode}
        model={selectedModel}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
      />
    </AnimatedContainer>
  );
};

export default Models;
